<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center text-center">
    <div class="col-12 col-xl-11">
      <h3 *ngIf="subscribe">{{ 'Newsletter subscribe'| translate }}</h3>
      <h3 *ngIf="!subscribe">{{ 'Newsletter unsubscribe'| translate }}</h3>
    </div>
  </div>
</div>
